module.exports = __webpack_public_path__ + "img/mccormick-fallback.18b5c18e.jpg";